import bezier from 'bezier-easing'

export default bezier(0.2, 1.61, 0.7, -0.1)
// export default bezier(0.13, 1.85, 0.57, -0.08)
